export const POPUP_MORE_IMAGES_TYPE = {
  nft: 'nft',
  image: 'image'
}
